<template>
  <v-form @submit.prevent="submit">
    <v-text-field
      v-model="show.name"
      label="Nome"
      :error-messages="error.name || ''"
      :readonly="!profile.is_staff"
      required
    ></v-text-field>
    <v-menu
      ref="dateMenu"
      :close-on-content-click="false"
      transition="scale-transition"
      offset-y
      allow-overflow
      min-width="290px"
    >
      <template v-slot:activator="{ on }">
        <v-text-field
          v-model="show.start_date"
          label="Data di inizio"
          :error-messages="error.start_date || ''"
          v-on="on"
        ></v-text-field>
      </template>
      <v-date-picker
        ref="picker"
        v-model="show.start_date"
        :readonly="!profile.is_staff"
      ></v-date-picker>
    </v-menu>
    <v-menu
      ref="dateMenu2"
      :close-on-content-click="false"
      transition="scale-transition"
      offset-y
      allow-overflow
      min-width="290px"
    >
      <template v-slot:activator="{ on }">
        <v-text-field
          v-model="show.end_date"
          label="Data di fine"
          :error-messages="error.end_date || ''"
          v-on="on"
        ></v-text-field>
      </template>
      <v-date-picker
        ref="picker"
        v-model="show.end_date"
        :readonly="!profile.is_staff"
      ></v-date-picker>
    </v-menu>

    <v-checkbox
      v-model="show.is_festival"
      label="Festival principale?"
      :readonly="!profile.is_staff"
    ></v-checkbox>

    <form-actions
      v-if="profile.is_staff"
      :loading="loading"
      @undo="reset"
      @submit="submit"
    />
  </v-form>
</template>

<script>
import { cloneDeep } from "@/lodash"

import models from "@/models"

export default {
  props: {
    withData: {
      type: Object,
      default: () => ({}),
    },
    error: {
      type: Object,
      default: () => ({}),
    },
    loading: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      show: {},
      personModel: models.Person,
      instrumentModel: models.Instrument,
    }
  },
  watch: {
    withData: {
      handler: "reset",
      deep: true,
    },
  },
  methods: {
    reset() {
      this.show = cloneDeep(this.withData)
    },
    submit() {
      this.$emit("submit", this.show)
    },
  },
}
</script>
